export default "__VITE_ASSET__Dup4Xpu7__"